import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationHostTypeService, ReferenceDataLabels } from 'rome-library';
import { States } from '../../../shared';
import { NotificationLoginService } from '../../services/notification-login.service';

@Component({
  selector: 'boi-session-end',
  templateUrl: 'session-end.component.html'
})
export class SessionEndComponent {
  public readonly referenceDataLabels = ReferenceDataLabels;

  @Input() public descriptionLabel: string;
  @Input() public titleLabel: string;

  constructor(
    private readonly router: Router,
    private readonly applicationHostTypeService: ApplicationHostTypeService,
    private readonly notificationLoginService: NotificationLoginService
  ) {}

  public goToLogin(): void {
    this.notificationLoginService.setNotificationType(undefined);
    void this.router.navigate([this.applicationHostTypeService.getCode(), States.Login]);
  }
}
